angular
  .module("myApp")
  .controller(
    "ContractManagerController",
    function (
      $scope,
      Notification,
      Codifiers,
      Dialog,
      $q,
      Upload,
      DocumentRemove,
      DocumentSave,
      DocumentPublish,
      DocumentUnpublish,
      DocumentRegen
    ) {
      $scope.contract = {
        me: "good",
      }

      $scope.kla = Codifiers.kla

      this.editDocument = (dto) => {
        const sabloni = Codifiers.sabloni()

        dto._sablonsChanged = () => {
          if (dto.sablons_id) {
            const sablons = _.find(sabloni, { id: dto.sablons_id })
            if (sablons) {
              dto.sablons_id = sablons.id
              dto.nosaukums = sablons.name
              dto.file_info.filename = sablons.filename
              dto.dokumenta_veids = sablons.sablona_tips
            }
          }
        }

        Dialog.dialog("pages/dialogs/pp.dokuments.form.html", dto, {}, (p, action) => {
          if (action !== "save") {
            return
          }

          p.pieteikums_id = $scope.dto.pieteikums_id

          if (!p.file) {
            return Dialog.finish(new DocumentSave(dto), $scope.reload)
          }

          return Upload.upload({
            url: "./upload",
            method: "POST",
            file: p.file,
          })
            .progress((evt) => {
              p.progress = {
                loaded: evt.loaded,
                total: evt.total,
              }
            })
            .then((response) => {
              p.file_info = response.data
              return Dialog.finish(new DocumentSave(dto), $scope.reload)
            })
            .catch((e) => {
              const data = e.data || e

              if (typeof data === "string" && data.includes("EntityStreamSizeException")) {
                return $q.reject("Ielādējamais fails ir par lielu.")
              }

              return $q.reject(data)
            })
        })
      }

      this.createDocument = () => {
        this.editDocument({ file_info: {} })
      }

      this.regenDocument = (l) => {
        if (!confirm(`Pārģenerēt "${l.nosaukums}" no šablona?`)) return
        const p = new DocumentRegen({ id: l.id })
        p.$save(() => {
          Notification.success(`"${l.nosaukums}" veiksmīgi pārģenerēts.`)
          $scope.reload()
        }, $scope.failing)
      }

      this.unpublishDokuments = (l) => {
        if (l.statuss !== "AKTUALS") return
        if (!confirm("Padarīt šo līgumu kā neaktuālu?")) return
        const p = new DocumentUnpublish({ id: l.id })
        p.$save(() => {
          Notification.success("Tagad šis dokuments tiek attēlots kā neaktīvs.")
          $scope.reload()
        }, $scope.failing)
      }

      this.activateDokuments = (l) => {
        if (l.statuss !== "MELNRAKSTS") return
        if (!confirm("Publicēt šo kā aktuālo versiju?")) return
        const p = new DocumentPublish({ id: l.id })
        p.$save(() => {
          Notification.success("Tagad šis dokuments ir pieejams lietotājam.")
          $scope.reload()
        }, $scope.failing)
      }

      this.removeDokuments = (l) => {
        if (l.statuss !== "MELNRAKSTS") return
        if (!confirm("Izdzēst šo melnrakstu?")) return
        const p = new DocumentRemove({ id: l.id })
        p.$save(() => {
          Notification.success("Melnraksts izdzēsts.")
          $scope.reload()
        }, $scope.failing)
      }
    }
  )

  .controller(
    "ContractUserController",
    function ($scope, Upload, Notification, PpAttachContractFile, PpRemoveContractAttachment) {
      $scope.upload = {}

      this.actual_uploader = (obj, form) => {
        $scope.upload.error = undefined
        $scope.upload.loading = true
        return Upload.upload({
          url: "./upload",
          method: "POST",
          file: $scope.upload.file,
        })
          .progress((evt) => {
            $scope.upload.progress = {
              loaded: evt.loaded,
              total: evt.total,
              // percentage: percentize(evt.loaded, evt.total)
            }
          })
          .success((data) => {
            obj.id = $scope.dto.id
            obj.file_id = data.id
            obj.pielikuma_veids = $scope.upload.pielikuma_veids
            obj.apraksts = $scope.upload.desc
            return obj.$save(
              () => {
                $scope.upload = {
                  loading: false,
                }
                form.$setPristine()
                return $scope.reload()
              },
              (e) => {
                $scope.upload = {
                  loading: false,
                }
                $scope.upload.error = e.data
                return Notification.error(e.data)
              }
            )
          })
          .error((data) => {
            $scope.upload = {
              loading: false,
            }
            form.$setPristine()
            if (data.indexOf("EntityStreamSizeException" > -1)) {
              $scope.upload.error = "Ielādējamais fails ir par lielu."
            } else {
              $scope.upload.error = data
            }
          })
      }

      this.uploadAttachment = (form) => {
        const v = new PpAttachContractFile()
        return this.actual_uploader(v, form)
      }

      this.removeAttachment = (a) => {
        if (!confirm("Izdzēst failu?")) {
          return
        }
        a = new PpRemoveContractAttachment({
          id: $scope.dto.id,
          file_id: a.id,
        })
        return a.$save(() => {
          Notification.success("Pielikums izdzēsts.")
          return $scope.reload()
        })
      }
    }
  )
